import fetch from './fetch'

export default {
  getPersonAdvocates (payload) {
    let request = fetch({
      url: '/advocate',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAdvocates (payload) {
    let request = fetch({
      url: '/advocate',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAdvocate (payload) {
    let request = fetch({
      url: '/advocate/',
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createAdvocate (payload) {
    let request = fetch({
      url: '/advocate',
      method: 'post',
      data: payload || {}
    })
    return request.call()
  },
  updateAdvocate (payload) {
    const { id, data } = payload

    let request = fetch({
      url: `/advocate/` + id,
      method: 'patch',
      data: data
    })

    return request.call()
  },
  deleteAdvocate (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/advocate/` + id,
      method: 'delete',
      data: data
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/advocate.js